module.exports = "<div class=app> <app-header></app-header> <app-sidebar></app-sidebar> <main class=main> <ui-view></ui-view> </main> </div> ";